document.addEventListener('DOMContentLoaded', () => {

  /* Ne rien faire sur mobile/tactile */
  if (!window.matchMedia('(hover: hover)').matches) return;

  const menus = Array.from(document.querySelectorAll('header details'));

  menus.forEach(menu => {
    const submenu = menu.querySelector('.mega-menu__content, ul, nav');

    /* --- Ouverture --- */
    menu.addEventListener('mouseenter', () => {
      /* Ferme les autres ouverts */
      menus.forEach(other => other !== menu && other.removeAttribute('open'));
      menu.setAttribute('open', '');
    });

    /* --- Fermeture (petit délai) --- */
    const close = () => setTimeout(() => {
      if (!menu.matches(':hover')) menu.removeAttribute('open');
    }, 1500);

    menu.addEventListener('mouseleave', close);
    submenu && submenu.addEventListener('mouseleave', close);
  });
  
});